<template>
    <div class="my-page">
        <div class="collate-top"></div>
        <div class="my-page-list">
            <!-- 1、用户信息及头像 -->
            <div v-if="userData" class='my-page-item-info dsp-flex'>
                <div class="my-page-info-box dsp-flex">
                    <div class="my-page-avatar-img"><img v-bind:src="userData.info.avatar" alt=""></div>
                    <div class="my-page-info">
                        <p class="my-page-nickname">{{userData.info.nickname}}</p>
                        <p class="my-page-sub-info">(ID:{{userData.info.uid}})</p>
                    </div>
                </div>
                <!-- <div class="my-page-more"><i class="iconfont icon-xiangyou"></i></div> -->
            </div>
            <!-- 2、八字工具 -->
            <div v-if="VIEW_CONFIG.showTool" class="my-page-item dsp-flex">
                <div class="my-page-item-left"><i class="iconbg icon-tool"></i>八字工具</div>
                <div class="my-page-more"><i class="iconfont icon-xiangyou"></i></div>
            </div>
            <!-- 3、生日提醒 -->
            <div v-if="VIEW_CONFIG.showBirth" class="my-page-item dsp-flex">
                <div class="my-page-item-left"><i class="iconbg icon-birth"></i>生日提醒</div>
                <div class="my-page-more"><i class="iconfont icon-xiangyou"></i></div>
            </div>
            <!-- 4、批盘记录 -->
            <div v-if="VIEW_CONFIG.showPi" class="my-page-item dsp-flex">
                <div class="my-page-item-left"><i class="iconbg icon-pi"></i>批盘记录</div>
                <div class="my-page-more"><i class="iconfont icon-xiangyou"></i></div>
            </div>
            <!-- 5、论盘记录 -->
            <div v-if="VIEW_CONFIG.showLun" class="my-page-item dsp-flex">
                <div class="my-page-item-left"><i class="iconbg icon-lun"></i>论盘记录</div>
                <div class="my-page-more"><i class="iconfont icon-xiangyou"></i></div>
            </div>
            <!-- 6、对比记录 -->
            <div v-if="VIEW_CONFIG.showCompare" class="my-page-item dsp-flex">
                <div class="my-page-item-left"><i class="iconbg icon-compare"></i>对比记录</div>
                <div class="my-page-more"><i class="iconfont icon-xiangyou"></i></div>
            </div>
            <!-- 7、我的数据报告 -->
            <div v-if="VIEW_CONFIG.showReport" class="my-page-item my-page-item-report dsp-flex">
                <div class="my-page-item-left"><i class="iconbg icon-report"></i>我的数据报告</div>
                <div class="my-page-more"><i class="iconfont icon-xiangyou"></i></div>
            </div>
            <!-- 8、反馈中心 -->
            <div v-if="VIEW_CONFIG.showFeedback" class="my-page-item dsp-flex">
                <div class="my-page-item-left"><i class="iconbg icon-feedback"></i>反馈中心</div>
                <div class="my-page-more"><i class="iconfont icon-xiangyou"></i></div>
            </div>
            <!-- 9、关于木火通明八字 -->
            <div v-if="VIEW_CONFIG.showAbout" class="my-page-item dsp-flex">
                <div class="my-page-item-left"><i class="iconbg icon-about"></i>关于木火通明八字</div>
                <div class="my-page-more"><i class="iconfont icon-xiangyou"></i></div>
            </div>
            <!-- 10、设置账号及密码 -->
            <div v-if="VIEW_CONFIG.showSet" class="my-page-item dsp-flex">
                <div class="my-page-item-left"><i class="iconbg icon-set"></i>设置账号及密码</div>
                <div class="my-page-more"><i class="iconfont icon-xiangyou"></i></div>
            </div>
            <!-- 11、捐赠 -->
            <div v-if="VIEW_CONFIG.showDonate" class="my-page-item dsp-flex">
                <div class="my-page-item-left"><i class="iconbg icon-donate"></i>捐赠</div>
                <div class="my-page-more"><i class="iconfont icon-xiangyou"></i></div>
            </div>
        </div>
    </div>
</template>

<script>
import { VIEW_CONFIG } from '../../modules/viewconfig'
export default {
    name: 'My',
    computed: {
        userData() {
            return this.$store.state.userData;
        }
    },
    data() {
        return {
            VIEW_CONFIG: VIEW_CONFIG
        }
    },
    methods: {

    }
}
</script>